// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, Stack } from '@metarouter-private/mr-mui';

import BulkApplyConsent from '../BulkApplyConsent';
import BulkApplyVariable from '../BulkApplyVariable';

/**
 * The inline header toolbar for the confirm-update table (rendered as the RDT
 * `title`): the bulk-apply consent and bulk-apply variable controls, each on its
 * own row, then the needs-attention filter on its own bottom row.
 */
export default function ConfirmUpdateToolbar({
  showOnlyIncomplete,
  onToggleShowOnlyIncomplete,
  consentCategoryEnabled,
  consentModeEnabled,
  variableNames,
  onApplied,
}) {
  return (
    <Stack spacing={1} width="100%">
      <BulkApplyConsent
        consentCategoryEnabled={consentCategoryEnabled}
        consentModeEnabled={consentModeEnabled}
        onApplied={onApplied}
      />
      <BulkApplyVariable variableNames={variableNames} onApplied={onApplied} />
      <FormControlLabel
        control={
          <Checkbox
            checked={showOnlyIncomplete}
            onChange={event => onToggleShowOnlyIncomplete(event.target.checked)}
            data-test-id="showOnlyIncompleteToggle"
          />
        }
        label="Only show pipelines requiring attention"
      />
    </Stack>
  );
}

ConfirmUpdateToolbar.propTypes = {
  showOnlyIncomplete: PropTypes.bool.isRequired,
  onToggleShowOnlyIncomplete: PropTypes.func.isRequired,
  consentCategoryEnabled: PropTypes.bool.isRequired,
  consentModeEnabled: PropTypes.bool.isRequired,
  variableNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onApplied: PropTypes.func.isRequired,
};
